<template>
    <fieldset v-if="tmpAddress">
        <div class="form-group row">
            <label :for="'org-adr-country-' + id" class="col-sm-4 col-form-label col-form-label-sm">
                Land:
            </label>
            <div class="col-sm-8">
                <afas-country-select :ref="'afas-country-select'" :key="tmpAddress.country" v-model="tmpAddress.country" :id="'org-adr-country-' + id"></afas-country-select>
                <div v-if="isInvalid('org-adr-country')" class="invalid-feedback invalid-feedback-force">
                    {{this.validationErrors['org-adr-country'].join(', ')}}
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-4 col-form-label col-form-label-sm">

            </label>
            <div class="col-sm-8">
                <b-form-checkbox data-hj-whitelist v-model="tmpAddress.postbus" :id="'org-is-postbus-' + id">Postbusadres</b-form-checkbox>
            </div>
        </div>

        <div class="form-group row">
            <label :for="'org-adr-street-' + id" class="col-sm-4 col-form-label col-form-label-sm">
                Straat:
            </label>
            <div class="col-sm-8">
                <input data-hj-whitelist type="text" :disabled="tmpAddress.postbus" :class="isInvalid('org-adr-street')" v-model="tmpAddress.street" class="form-control form-control-sm" :id="'org-adr-street-' + id" placeholder="">

                <div v-if="isInvalid('org-adr-street')" class="invalid-feedback invalid-feedback-force">
                    {{this.validationErrors['org-adr-street'].join(', ')}}
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label :for="'org-adr-number-' + id" class="col-sm-4 col-form-label col-form-label-sm">
                {{tmpAddress.postbus ? 'Postbusnummer' : 'Huisnummer' }}:
            </label>
            <div class="col-sm-8">
                <div class="row">
                    <div class="col-sm-4">
                        <input data-hj-whitelist type="number" min="1" v-model.number="tmpAddress.number" :class="isInvalid('org-adr-number')"
                               class="form-control form-control-sm" :id="'org-adr-number-' + id" placeholder="">
                        <div v-if="isInvalid('org-adr-number')" class="invalid-feedback invalid-feedback-force">
                            {{this.validationErrors['org-adr-number'].join(', ')}}
                        </div>
                    </div>
                    <div class="col-sm-8">
                        <div class="row">
                            <label :for="'org-adr-addition-' + id" class="col-sm-5 col-form-label col-form-label-sm">
                                Toev.:
                            </label>
                            <div class="col-sm-7">
                                <input data-hj-whitelist type="text" :disabled="tmpAddress.postbus" v-model="tmpAddress.number_addition" :class="isInvalid('org-adr-addition')" class="form-control form-control-sm" :id="'org-adr-addition-' + id" placeholder="">
                                <div v-if="isInvalid('org-adr-addition')" class="invalid-feedback invalid-feedback-force">
                                    {{this.validationErrors['org-adr-addition'].join(', ')}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label :for="'org-adr-zip-' + id" class="col-sm-4 col-form-label col-form-label-sm">
                Postcode:
            </label>
            <div class="col-sm-8">
                <div class="row">
                    <div class="col-sm-4">
                        <input data-hj-whitelist type="text" v-model="tmpAddress.zip" class="form-control form-control-sm" :class="isInvalid('org-adr-zip')" :id="'org-adr-zip-' + id" placeholder="">
                        <div v-if="isInvalid('org-adr-zip')" class="invalid-feedback invalid-feedback-force">
                            {{this.validationErrors['org-adr-zip'].join(', ')}}
                        </div>
                    </div>
                    <div class="col-sm-8">
                        <div class="row">

                            <label :for="'org-adr-city-' + id" class="col-sm-5 col-form-label col-form-label-sm">
                                Woonplaats:
                            </label>
                            <div class="col-sm-7">
                                <input data-hj-whitelist type="text" v-model="tmpAddress.city" class="form-control form-control-sm" :class="isInvalid('org-adr-city')" :id="'org-adr-city-' + id" placeholder="">
                                <div v-if="isInvalid('org-adr-city')" class="invalid-feedback invalid-feedback-force">
                                    {{this.validationErrors['org-adr-city'].join(', ')}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
</template>

<script>
    import afasCountrySelect from './afasCountrySelect';
    export default {
        components: {
            afasCountrySelect
        },
        data() {
            return {
                validationErrors: [],

                tmpAddress: {
                    country: 'NL',
                    street: '',
                    number: '',
                    number_addition: '',
                    zip: '',
                    city: ''
                },
                searchForAddress: ''

            }
        },
        props: {
            value: {
                type: Object
            },
            id: {
                type: String
            }
        },
        watch: {
            value: {
                handler: function (val, oldVal) {
                    this.tmpAddress = val !== null ? val : {
                        country: 'NL',
                        street: '',
                        number: '',
                        number_addition: '',
                        zip: '',
                        city: ''
                    };
                },
                deep: true
            },
            tmpAddress: {
                handler: function (val, oldVal) {
                    if (this.tmpAddress && this.tmpAddress.country) {
                        this.$refs['afas-country-select'].select(this.tmpAddress.country);
                    }
                    this.update();
                },
                deep: true
            }
        },
        mounted() {
            this.tmpAddress = this.value;
        },
        computed: {
            isNotNetherlands: function () {
                return this.tmpAddress.country !== 'NL';
            }
        },
        methods: {
            update() {
                this.$emit('input', this.tmpAddress);
            },
            validate() {

                let err = [];

                if(!this.tmpAddress.postbus) {
                    if(this.tmpAddress.street === undefined || this.tmpAddress.street === null || this.tmpAddress.street.length < 2) {
                        err['org-adr-street'] = [
                            'Vul een geldige straatnaam in.'
                        ];
                    }
                }
                if(this.tmpAddress.number === undefined || this.tmpAddress.number === null || (typeof this.tmpAddress.number === 'string' && this.tmpAddress.number.trim() === '') || this.tmpAddress.number < 1) {
                    err['org-adr-number'] = [
                        'Vul een geldig huisnummer in.'
                    ];
                }

                let zipRegex = /[1-9][0-9]{3}[\s]?[A-Za-z]{2}/gi;
                if(this.tmpAddress.zip === undefined || this.tmpAddress.zip === null || (this.tmpAddress.zip.length < 4 || (this.tmpAddress.country === 'NL' && this.tmpAddress.zip.search(zipRegex) === -1))) {
                    err['org-adr-zip'] = [
                        'Vul een geldige postcode in.'
                    ];
                }
                if(this.tmpAddress.city === undefined || this.tmpAddress.city === null || this.tmpAddress.city.trim() === '' || this.tmpAddress.city < 2) {
                    err['org-adr-city'] = [
                        'Vul een geldige woonplaats in.'
                    ];
                }
                if(this.tmpAddress.country === undefined || this.tmpAddress.country === null || this.tmpAddress.country.trim() === '') {
                    err['org-adr-country'] = [
                        'Selecteer een land.'
                    ];
                }
                this.validationErrors = err;
                return Object.keys(err).length === 0
            },
            fillAddressFromSearch() {
                let check = this.searchForAddress.trim();
                if(check === '') {
                    return;
                }
                let zipRegex = /[1-9][0-9]{3}[\s]?[A-Za-z]{2}/gi;
                let zipResults = this.searchForAddress.match(zipRegex);

                let zip = zipResults !== null && zipResults.hasOwnProperty(0) ? zipResults[0] : '';
                let numberSearch = this.searchForAddress.replace(zip, '');

                let numberRegex = /\d+/g;
                let numberResults = numberSearch.match(numberRegex);
                let number = numberResults !== null && numberResults.hasOwnProperty(0) ? numberResults[0] : '';
                let numberAddition = numberSearch.replace(number, '').trim();

                this.tmpAddress.zip = zip;
                this.tmpAddress.number = number;
                this.tmpAddress.number_addition = numberAddition;
            },
            isInvalid(key) {
                if(this.validationErrors.hasOwnProperty(key)) {
                    return 'is-invalid';
                }
                return '';
            }
        }
    }
</script>

<style lang="scss">
</style>